module.exports = __webpack_public_path__ + "imgs/mjfreeway.f1b41d4517bcd5d17a68197d67b46bfa.jpg";